<!--
NOTE: ai 治疗方案。
同治疗方案。，但是展示以及所对应的业务不同，单独拎出来进行改造
-->
<script setup>
import { prescriptionList } from '@/api/workPlace/prescription'
import { ref, reactive, defineProps, onMounted } from 'vue'
import { columnsToOnline } from './config.js'
import TheDetail from '@/components/TheDetail/index.vue'
import { calcDiagnosis } from '@/utils/index'
// NOTE:关于列表
// 详情页的显示隐藏
const loading = ref(false)
const visible = ref(false)
// 表格内的数据
const data = reactive({
  // 表格
  table: [],
  // 表格中被点击的每一条数据的唯一标识：serialNumber (线下弃用)
  serialNumber: ''
})
const props = defineProps({
  parentSns: {
    type: Array,
    default: () => []
  }
})
// 获取电子处方列表信息
function getPrescription() {
  data.table.splice(0)
  loading.value = true
  prescriptionList(props.parentSns)
    .then(resolve => {
      // const [tmp] = resolve
      data.table = resolve
    })
    .catch(e => {
      console.log(e)
    })
    .finally(() => (loading.value = false))
}
// 点击后的操作
const onOperation = ({ record }) => {
  visible.value = true
  data.serialNumber = record.parentSn
}
onMounted(() => {
  getPrescription()
})
</script>

<template>
  <div class="prescription">
    <!-- 表格 -->
    <a-table
      :loading="loading"
      class="table"
      :pagination="false"
      rowKey="id"
      :columns="columnsToOnline"
      :data-source="data.table"
      :transformCellText="({ text }) => text ?? '--'"
      show-quick-jumper
      :scroll="{ x: 100 }"
      tableLayout="auto"
    >
      <!-- 诊断 -->
      <template #diagnosisInfoList="{ record }">
        <span class="elip--multiple" :style="{ '-webkit-line-clamp': '2' }">
          {{ calcDiagnosis(record, 'diagnosisInfoList', 'diagnosis') }}
        </span>
      </template>
      <!-- 操作 -->
      <template #handle="data">
        <a-button class="button-link" type="link" @click="onOperation(data)">查看详情</a-button>
      </template>
    </a-table>
    <!-- 弹出框 -->
    <the-detail
      recordType="prescriptionGroup"
      v-model:visible="visible"
      :serialNumber="data.serialNumber"
    />
  </div>
</template>

<style lang="scss" scoped>
.prescription {
  .header {
    margin: 20px 0 8px;
    font-weight: 500;
    color: #333333;
    font-size: 14px;
    // .top {
    //   font-size: 16px;
    //   margin-bottom: 16px;
    // }
  }
  .table {
    .button-link {
      padding: 0;
    }
  }
}
</style>
